import { render, staticRenderFns } from "./vue-view-test.vue?vue&type=template&id=1b8ec4a6&scoped=true"
import script from "./vue-view-test.vue?vue&type=script&lang=js"
export * from "./vue-view-test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ec4a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b8ec4a6')) {
      api.createRecord('1b8ec4a6', component.options)
    } else {
      api.reload('1b8ec4a6', component.options)
    }
    module.hot.accept("./vue-view-test.vue?vue&type=template&id=1b8ec4a6&scoped=true", function () {
      api.rerender('1b8ec4a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vue-view-test/vue-view-test.vue"
export default component.exports